
/* global google */
/* eslint-disable */
/* */
import { defineComponent, watch, ref } from 'vue';
import { mapGetters } from 'vuex';
import Summary from '@/components/SurveyDetails/Summary/index.vue';
import SurveyManagerComponent from '@/components/SurveyDetails/Summary/SurveyManager.vue';
import SurveySupervisorsComponent from '@/components/SurveyDetails/Summary/SurveySupervisors.vue';
import MetadataExpanded from '@/components/SurveyDetails/MetadataExpand/index.vue';
import { DEFAULT_MAP_OPTIONS } from '@/utils/map';

export default defineComponent({
  name: 'SurveyMetadata',
  setup() {
    const metaMapRef = ref();
    watch(metaMapRef, (googleMap) => {
      if (googleMap) {
        googleMap.$mapPromise.then((map:any) => {
          const controlUI = document.createElement('button');
          controlUI.setAttribute('id', 'metaMapCntrl');
          controlUI.classList.add('nav-map-cntrl');
          controlUI.classList.add("gm-control-active") ;
          controlUI.title = 'Click to center the map';
          // @ts-expect-error
          map.controls[google.maps.ControlPosition.TOP_RIGHT].push(controlUI);
        });
      }
    });
    return {
      metaMapRef,
    };
  },
  components: {
    Summary,
    MetadataExpanded,
    SurveyManagerComponent,
    SurveySupervisorsComponent,
  },
  computed: {
    ...mapGetters('survey', [
      'getName',
      'getOrganization',
      'getDateOfSurvey',
      'getSurveyType',
      'getSamplingMethod',
      'getSurveyManager',
      'getSupervisors',
      'getLocation',
      'getCoordinates',
    ]),
    mapOptions() {
      const mapOptions = { ...DEFAULT_MAP_OPTIONS };
      mapOptions.zoomControl = true;
      mapOptions.fullscreenControl = true;
      mapOptions.draggable = true;
      mapOptions.gestureHandling = 'cooperative';
      return mapOptions;
    },
  },
  methods: {
    reCenter() {
      const controlUI = document.getElementById('metaMapCntrl');
      if (controlUI) {
        controlUI.addEventListener('click', () => {
          this.metaMapRef.$mapPromise.then((map:any) => {
            map.setCenter(this.getCoordinates);
          })
        })
      }
    },
  },
});

